module.exports = __webpack_public_path__ + "media/images/LearnMore21-208f61bf431138c77563ca7b7c02a845.png";